import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-soc-l1-assortment",
  "use": "icon-soc-l1-assortment-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 1024 1024\" id=\"icon-soc-l1-assortment\">\r\n<g transform=\"translate(-80 -80) scale(1.18)\" fill=\"currentColor\">\r\n<rect x=\"192\" y=\"224\" width=\"192\" height=\"192\" rx=\"24\" /><rect x=\"416\" y=\"224\" width=\"192\" height=\"192\" rx=\"24\" /><rect x=\"640\" y=\"224\" width=\"192\" height=\"192\" rx=\"24\" /><rect x=\"192\" y=\"448\" width=\"192\" height=\"192\" rx=\"24\" /><rect x=\"416\" y=\"448\" width=\"192\" height=\"192\" rx=\"24\" /><rect x=\"640\" y=\"448\" width=\"192\" height=\"192\" rx=\"24\" /><rect x=\"192\" y=\"672\" width=\"192\" height=\"128\" rx=\"24\" /><rect x=\"416\" y=\"672\" width=\"192\" height=\"128\" rx=\"24\" /><rect x=\"640\" y=\"672\" width=\"192\" height=\"128\" rx=\"24\" /><circle cx=\"800\" cy=\"224\" r=\"48\" />\r\n</g>\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/soc-l1-assortment.svg
// module id = xtgB
// module chunks = 491